"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setAddinObserverLoaded ')(function updateInstalledAddins() {
    // Framework team has plans to implement a .isLoaded property for lazy imports.
    // This will allow a component to re-render when the import finishes. Until this is available,
    // we'll use our own boolean in the store. WI: 23555
    store_1.default.isAddinObserverLoaded = true;
});
//# sourceMappingURL=setAddinObserverLoaded.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-surface-actions/lib/actions/setAddinObserverLoaded.js
// module id = 3092
// module chunks = 2 3 4